export enum UserRole {
  PARENT = 'PARENT',
  CAREGIVER = 'CAREGIVER',
  CLINICIAN = 'CLINICIAN',
  INTERNS = 'INTERNS',
  ORG_ADMIN = 'ORG_ADMIN',
  SUPER_ADMIN = 'SUPER_ADMIN',
  SME = 'SME',
  DOCTOR = 'DOCTOR',
  THERAPIST = 'THERAPIST',
  ADMIN = 'ADMIN',
  TEACHER = 'TEACHER',
  DAYCARE = 'DAYCARE',
  USER = 'USER',
  MODERATOR = 'MODERATOR'
}

export interface User {
  id: string;
  email: string;
  role: UserRole;
  username: string;
  avatar?: string;
  organizationId?: string;
}

export interface AuthState {
  user: User | null;
  isAuthenticated: boolean;
  isLoading: boolean;
} 
